// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RuB62","col":"styles_col__3yhdi"};